import { cartTemplate } from './cart-template';
import { filterOptionBoxTemplate } from './option-box-template';
import { filterOptionListTemplate } from './option-list-template';
import { filterOptionMultiLevelCollection } from './option-multi-level-collection-template';
import { filterOptionMultiLevelTagTemplate } from './option-multi-level-tag-template';
import { filterOptionRatingTemplate } from './option-rating-template';
import { filterOptionSwatchTemplate } from './option-swatch-template';
import { preOrderTemplate } from './pre-order-template';
import { productPriceTemplate } from './product-price';
import { refineByHorizontalTemplate } from './refine-by-horizontal-template';
import { refineByTemplate } from './refine-by-template';
import { searchTabCollectionsTemplate } from './search-tab-collections-template';
import { searchTabPagesTemplate } from './search-tab-pages-template';
import { searchTabPaginationTemplate } from './search-tab-pagination-template';

export { cartTemplate } from './cart-template';
export { filterOptionBoxTemplate } from './option-box-template';
export { filterOptionListTemplate } from './option-list-template';
export { filterOptionMultiLevelCollection } from './option-multi-level-collection-template';
export { filterOptionMultiLevelTagTemplate } from './option-multi-level-tag-template';
export { filterOptionRatingTemplate } from './option-rating-template';
export { filterOptionSwatchTemplate } from './option-swatch-template';
export { preOrderTemplate } from './pre-order-template';
export { productPriceTemplate } from './product-price';
export { refineByHorizontalTemplate } from './refine-by-horizontal-template';
export { refineByTemplate } from './refine-by-template';
export { searchTabCollectionsTemplate } from './search-tab-collections-template';
export { searchTabPagesTemplate } from './search-tab-pages-template';
export { searchTabPaginationTemplate } from './search-tab-pagination-template';

const TEMPLATE_MAPPING = {
  refineByTemplate: 'refineBy',
  filterOptionListTemplate: 'filterOptionListItem',
  filterOptionBoxTemplate: 'filterOptionBoxItem',
  filterOptionSwatchTemplate: 'filterOptionSwatchItem',
  filterOptionMultiLevelCollection: 'filterOptionMultiLevelCollectionItem',
  filterOptionMultiLevelTagTemplate: 'filterOptionMultiLevelTagItem',
  filterOptionRatingItemTemplate: 'filterOptionRatingItem',
  cartTemplate: 'cart',
  productPriceTemplate: 'productPrice',
  searchTabCollectionsTemplate: 'searchTabCollectionsContent',
  searchTabPagesTemplate: 'searchTabPagesContent',
  searchTabPaginationTemplate: 'searchTabCollectionsContentPagination',
  preOrderTemplate: 'preOrder',
};
function getCustomizedTemplate(context, templateKey, defaultTemplate) {
  // Comment not Delete - Will uncomment when update lasted default template
  const templateKeyFromMetafield = TEMPLATE_MAPPING[templateKey];
  const templateParsed = context?.app?.templateParsed || {};
  const template = context.app?.template || undefined;
  if (templateKeyFromMetafield && templateParsed && templateParsed[templateKeyFromMetafield]) {
    return templateParsed[templateKeyFromMetafield];
  }
  if (templateKeyFromMetafield && template && template[templateKeyFromMetafield]) {
    return template[templateKeyFromMetafield];
  }

  return defaultTemplate;
}

export function getTemplate(context) {
  return {
    refineByTemplate: getCustomizedTemplate(context, 'refineByTemplate', refineByTemplate),
    refineByHorizontalTemplate: getCustomizedTemplate(
      context,
      'refineByHorizontalTemplate',
      refineByHorizontalTemplate
    ),
    filterOptionListTemplate: getCustomizedTemplate(
      context,
      'filterOptionListTemplate',
      filterOptionListTemplate
    ),
    filterOptionBoxTemplate: getCustomizedTemplate(
      context,
      'filterOptionBoxTemplate',
      filterOptionBoxTemplate
    ),
    filterOptionSwatchTemplate: getCustomizedTemplate(
      context,
      'filterOptionSwatchTemplate',
      filterOptionSwatchTemplate
    ),
    cartTemplate: getCustomizedTemplate(context, 'cartTemplate', cartTemplate),
    productPriceTemplate: getCustomizedTemplate(
      context,
      'productPriceTemplate',
      productPriceTemplate
    ),
    filterOptionRatingTemplate: getCustomizedTemplate(
      context,
      'filterOptionRatingTemplate',
      filterOptionRatingTemplate
    ),
    filterOptionMultiLevelTagTemplate: getCustomizedTemplate(
      context,
      'filterOptionMultiLevelTagTemplate',
      filterOptionMultiLevelTagTemplate
    ),
    filterOptionMultiLevelCollection: getCustomizedTemplate(
      context,
      'filterOptionMultiLevelCollection',
      filterOptionMultiLevelCollection
    ),
    searchTabCollectionsTemplate: getCustomizedTemplate(
      context,
      'searchTabCollectionsTemplate',
      searchTabCollectionsTemplate
    ),
    searchTabPagesTemplate: getCustomizedTemplate(
      context,
      'searchTabPagesTemplate',
      searchTabPagesTemplate
    ),
    searchTabPaginationTemplate: getCustomizedTemplate(
      context,
      'searchTabPaginationTemplate',
      searchTabPaginationTemplate
    ),
    preOrderTemplate: getCustomizedTemplate(context, 'preOrderTemplate', preOrderTemplate),
  };
}
